import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://olvymnsfrkhhajmkiaog.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9sdnltbnNmcmtoaGFqbWtpYW9nIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI2MzUxODksImV4cCI6MjA0ODIxMTE4OX0.iuh1hPGkxZbZ3boBXxT5eHT1Ezgt5i4uMHdw2oVrtxc";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
